"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWithIcon = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
exports.ButtonWithIcon = function (props) {
    return (react_1.default.createElement(sdk_ui_kit_1.DropdownButton, { value: props.value, isSmall: false, className: "gd-button-small " + props.className, iconLeft: props.icon, isOpen: props.isOpen, onClick: props.onClick }));
};
//# sourceMappingURL=ButtonWithIcon.js.map